<!-- Globe Explorer: Fullscreen layout with transparent header overlay -->
<ng-container *ngIf="isGlobeRoute">
  <div class="globe-fullscreen">
    <app-menu *ngIf="!hideHeader" class="globe-header-overlay"></app-menu>
    <router-outlet></router-outlet>
  </div>
</ng-container>

<!-- Signup Page Layout: Full Video Background + Sticky Navbar + Centered Form + Authentic Dark Footer -->
<ng-container *ngIf="!isGlobeRoute && isSignUpRoute">
  <!-- Sticky Header: Always visible at top with logo -->
  <app-menu *ngIf="!hideHeader" class="signup-header-overlay"></app-menu>

  <div class="signup-page-container" id="signupPageContainer">

    <!-- Video Background: Fullscreen fixed background for all screens -->
    <div class="signup-video-bg">
      <!-- Thumbnail image shown immediately till video is fetched & ready -->
      <img
        *ngIf="posterUrl"
        class="bg-poster"
        [src]="posterUrl"
        alt="Destination Background"
        [class.fade-out]="isVideoLoaded"
      />
      <video
        #bgVideo
        class="bg-video"
        [class.loaded]="isVideoLoaded"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        preload="auto"
        [poster]="posterUrl"
        (canplay)="onVideoCanPlay()"
        (loadeddata)="onVideoCanPlay()"
        (timeupdate)="onVideoTimeUpdate()"
      >
        <source *ngIf="videoBlobUrl" [src]="videoBlobUrl" type="video/mp4">
        <ng-container *ngIf="!videoBlobUrl">
          <source *ngFor="let s of candidateSources" [src]="s.url" [type]="s.type">
        </ng-container>
      </video>
      <div class="bg-vignette-overlay" [class.loaded]="isVideoLoaded"></div>


      <!-- Destination Location Overlay Text (Gold small caps region line + White bold place name) -->
      <div
        class="video-location-badge"
        *ngIf="currentLocationScene"
        [class.loaded]="isVideoLoaded"
        [class.visible]="isLocationTextVisible"
        aria-live="polite"
      >
        <span class="location-region">{{ currentLocationScene.region }}</span>
        <span class="location-place">{{ currentLocationScene.place }}</span>
      </div>
    </div>

    <!-- MOBILE ONLY: Screen 1 Peek Area (Video background with centered "Scroll to Apply" cue, form peeks at bottom) -->
    <div class="signup-mobile-peek-spacer d-lg-none" id="mobilePeekSpacer">
      <div class="mobile-scroller-cue" (click)="scrollToSignupForm()" role="button" tabindex="0" aria-label="Scroll to sign up form">
        <div class="scroller-pill">
          <div class="scroller-icon-circle">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#ffcc03" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="18 15 12 9 6 15"></polyline>
              <polyline points="18 9 12 3 6 9" opacity="0.6"></polyline>
            </svg>
          </div>
          <span class="scroller-label">Scroll to Apply</span>
        </div>
      </div>
    </div>

    <!-- Screen 2: Sign-Up Form Section (Centered on Mobile, 2-Column Row on Desktop) -->
    <div class="signup-page-wrapper" id="signupFormSection">
      <!-- Main Content Container with Router Outlet -->
      <div class="signup-content-area container-fluid">
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- Screen 3: Footer -->
    <app-footer *ngIf="!hideFooter" class="signup-footer" id="signupFooterSection"></app-footer>
  </div>
</ng-container>

<!-- Normal App Layout: Standard layout for other steps (OTP, KYC, etc.) -->
<ng-container *ngIf="!isGlobeRoute && !isSignUpRoute">
  <app-menu *ngIf="!hideHeader" class="journey-header-overlay"></app-menu>
  <div class="journey-page-container" id="journeyPageContainer">
      <!-- Fixed Destination Background Image Layer for all post-signup pages -->
      <div class="journey-bg-layer" [style.background-image]="journeyBackgroundUrl ? 'url(' + journeyBackgroundUrl + ')' : 'none'"></div>
      <div class="journey-bg-overlay"></div>

      <div class="applicationFormDiv journey-main-content">
          <div class="container formDiv">
              <div class="row justify-content-center">
                  <div class="col-12 col-xl-11 rightSection">
                      <div class="journey-content-wrapper">
                          <router-outlet></router-outlet>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <app-footer *ngIf="!hideFooter" class="journey-footer"></app-footer>
  </div>
</ng-container>